(function() {
    'use strict';

    function globalLaunchSlider() {
        var screenWdt = document.documentElement.clientWidth,
            elParent = document.getElementsByClassName( 'recommendation-slider')[0],
            elList = document.getElementsByClassName( 'recommendation-content-slider')[0],
            elItem = document.getElementsByClassName( 'slider-item'),
            lastItem = 0,
            leftBtn = document.getElementsByClassName( 'recommendation-left-slider')[0],
            rightBtn = document.getElementsByClassName( 'recommendation-right-slider')[0],
            itemWidth = 0,
            nbItem = 1,
            nbFilterItem = 8,
            secondListHtml = '',
            screenWdtDetect = function() {
                if( screenWdt < 320) { nbFilterItem = 1; }
                else if( screenWdt < 568) { nbFilterItem = 2; }
                else if( screenWdt < 800) { nbFilterItem = 4; }
                else if( screenWdt < 1024) { nbFilterItem = 5; }
                else if( screenWdt < 1280) { nbFilterItem = 6; }
                else { nbFilterItem = 8; }
            },
            elListWidth = function() {
                for( var i=0; i< elItem.length; i++) {
                    //Inject data-src attribut datas in img src attribut
                    var src = elItem[i].firstElementChild.getAttribute('data-src');
                    elItem[i].firstElementChild.setAttribute('src', src);
                    //Get width img
                    if( i < 16) {
                        nbItem = ++nbItem;
                        itemWidth = itemWidth+parseInt( elItem[i].offsetWidth, 10);
                    }
                }
                var calculateWdt = parseInt( (itemWidth*2)+(nbFilterItem*elItem[0].offsetWidth), 10)
                elList.style.width = calculateWdt+'px';
            },
            setSecondListHtml = function() {
                //Get n first items of the list loop
                for( var i=0; i< elItem.length; i++) {
                    if( i <= nbFilterItem) {
                        secondListHtml += elItem[i].outerHTML;
                    }
                }
                //Add them after the last item
                lastItem = --nbItem-1;
                elItem[lastItem].insertAdjacentHTML( 'afterend', secondListHtml);
            },
            launchSlider = function( parent, nbFilter) {
                var left = parseInt((-itemWidth/nbItem)*nbFilterItem),
                    leftTotal = 0,
                    moveLeft = function() {
                        if( parseInt(leftTotal) > -itemWidth-left) {
                            leftTotal = parseInt(leftTotal+left);
                            elList.style.left = parseInt(leftTotal) + 'px';
                        }
                        else {
                            elList.style.left = 0;
                            leftTotal = 0;
                        }
                    };
                setInterval( moveLeft, 3000);
            },
            clickLeftSlider = function(e) {
                e.preventDefault();
                elList.style.left = 0 + 'px';
            },
            clickRightSlider = function(e) {
                e.preventDefault();
                var left = parseInt((-itemWidth/nbItem)*nbFilterItem);
                elList.style.left = parseInt(-itemWidth-left) + 'px';
            }
            ;
        if( elParent) {
            screenWdtDetect();
            elListWidth();
            setSecondListHtml();
            leftBtn.addEventListener( 'click', clickLeftSlider);
            rightBtn.addEventListener( 'click', clickRightSlider);
        }
    };

    document.addEventListener( 'DOMContentLoaded', function() {
        globalLaunchSlider();
    });

    window.addEventListener( 'resize', function() {
        setTimeout( globalLaunchSlider, 1000);
    });

})();
